import { render, staticRenderFns } from "./qianyueList.vue?vue&type=template&id=b2067cde&scoped=true&"
import script from "./qianyueList.vue?vue&type=script&lang=js&"
export * from "./qianyueList.vue?vue&type=script&lang=js&"
import style0 from "./qianyueList.vue?vue&type=style&index=0&id=b2067cde&scoped=true&lang=css&"
import style1 from "./qianyueList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2067cde",
  null
  
)

export default component.exports